import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { T, t } from '@sm/intl';
import { Button } from '@wds/button';
import { Modal } from '@wds/modal';
export const COPY = {
  header: {
    id: 'OpenEndedCoding.DiscardKeywordGenerationModal.header',
    defaultMessage: 'Exit keyword extraction?',
    description: '[Type: Header][Vis: med] - Header for Discard Keyword Generation Modal'
  },
  description: {
    id: 'OpenEndedCoding.DiscardKeywordGenerationModal.description',
    defaultMessage: 'Are you sure you want to exit? This will cancel keyword extraction and take you back to the responses page.',
    description: '[Type: Header][Vis: med] - Discard Keyword Generation Modal description'
  },
  cancel: {
    id: 'OpenEndedCoding.DiscardKeywordGenerationModal.cancel',
    defaultMessage: 'Cancel',
    description: '[Type: Header][Vis: med] - Discard Keyword Generation Modal cancel button'
  },
  exit: {
    id: 'OpenEndedCoding.DiscardKeywordGenerationModal.exit',
    defaultMessage: 'Exit',
    description: '[Type: Header][Vis: med] - Discard Keyword Generation Modal exit button'
  }
};
const DiscardKeywordGenerationModal = ({
  show,
  onExit,
  onCancel
}) => {
  return _jsxs(Modal, {
    "data-testid": "DiscardKeywordsGenerationModal__OEC",
    show: show,
    onClose: onCancel,
    children: [_jsx(Modal.Header, {
      header: t(COPY.header)
    }), _jsx(Modal.Body, {
      children: _jsx(T, {
        desc: COPY.description
      })
    }), _jsxs(Modal.Footer, {
      align: "right",
      children: [_jsx(Button, {
        variant: "ghost",
        color: "secondary",
        onClick: onCancel,
        children: _jsx(T, {
          desc: COPY.cancel
        })
      }), _jsx(Button, {
        color: "warning",
        onClick: onExit,
        children: _jsx(T, {
          desc: COPY.exit
        })
      })]
    })]
  });
};
export default DiscardKeywordGenerationModal;